export default "__VITE_ASSET__KvvBug4I__"